<template>
	<v-avatar
			ref="avatar"
			:class="{ grouped: grouped }"
			:color="customColor ?? color"
			:size="size_"
			:style="`margin-left: -${!firstItem && grouped ? size * 0.4 : 0}px;`"
	>
		<template v-if="user">
			<img
					v-if="user[profileImageKey]?.fullUri"
					:height="size_"
					:src="user[profileImageKey].fullUri"
					:width="size_"
					alt="Avatar"
			>
			<span
					v-else
					:style="`font-size: ${size * 0.53}px`"
					class="white--text"
					v-text="
						`${user.firstName.charAt(0)}${
							user.lastName ? user.lastName.charAt(0) : ''
						}`
					"
			/>
		</template>
		<span
				v-else
				:style="`font-size: ${size * 0.53}px`"
				class="white--text"
				v-text="defaultText"
		/>
	</v-avatar>
</template>

<script>
import { getAvatarColor } from "@/utils/generator";

export default {
  props: {
    size: { type: Number, required: false, default: null },
    user: { type: Object, required: false, default: null },
    profileImageKey: { type: String, required: false, default: null },
    firstItem: { type: Boolean, required: false, default: false },
    grouped: { type: Boolean, required: false, default: false },
    defaultText: { type: String, required: false, default: "" },
    customColor: { type: String, required: false, default: null },
  },
  data() {
    return {
      size_: "100%",
    };
  },
  computed: {
    fullName() {
      if (!this.user) return this.defaultText;
      return `${this.user.firstName} ${this.user.lastName}`;
    },
    color() {
      return getAvatarColor(this.fullName);
    },
  },
  mounted() {
    if (this.size) this.size_ = this.size;
    else {
      setTimeout(() => {
        this.size_ = this.$refs.avatar.$el.clientWidth;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.grouped {
  border-color: #fff !important;
  border-style: solid;
  border-width: 2px;
  text-decoration: none;

  &:hover {
    z-index: 9;
  }
}
</style>
